import { render, staticRenderFns } from "./TemplateType3.vue?vue&type=template&id=67b80f46&scoped=true&"
import script from "./TemplateType3.vue?vue&type=script&lang=js&"
export * from "./TemplateType3.vue?vue&type=script&lang=js&"
import style0 from "./TemplateType3.vue?vue&type=style&index=0&id=67b80f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b80f46",
  null
  
)

export default component.exports